export interface AuditActor {
  uid: string
  name: string
}

let currentActor: AuditActor = { uid: '', name: '' }

export function setAuditActor(actor: AuditActor | null): void {
  if (!actor || !actor.uid) {
    currentActor = { uid: '', name: '' }
    return
  }
  currentActor = {
    uid: actor.uid,
    name: actor.name.trim() || actor.uid,
  }
}

export function getAuditActor(): AuditActor {
  return currentActor
}
